export default __webpack_public_path__ + "static/media/home-20x20.4dc24dc8.svg";